import { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
    PopupDto,
    PopupService,
} from "../api/psc";
import { DialogContext } from "../contexts/DialogContext";
import { IntegrationContext } from "../contexts/IntegrationContext";
import { UserContext } from "../contexts/UserContext";
import Popup from "../features/popup/Popup";
import UserPolicyNotice from "../features/management/UserPolicyNotice";
import { RootState } from "../slices/Store";
import { checkVersionAndUpdateIfNeeded } from "../utils/app";
import { USER_POLICY_NOTICE_STORAGE_PREFIX } from "../utils/storage";

export default function Requirements(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const user = useContext(UserContext);

    const { openDialog } = useContext(DialogContext);
    const integration = useContext(IntegrationContext);
    const accountDetail = useSelector((state: RootState) => state.shared.accountDetail);
    const shownPolicyNotices = useRef(new Set<string>());
    const policyNoticeOpen = useRef(false);

    const activityState = useSelector(
        (state: RootState) => state.activityState
    );

    useEffect(() => {
        integration.refreshBadgeCount();
    }, [
        activityState.reminderNotificationBadgeCount,
        activityState.taskNotificationBadgeCount,
    ]);

    useEffect(() => {
        if (user === null) {
            return;
        }
        const timer = setInterval(() => {
            processScaffoldRequirements().then();
        }, 60000);
        return () => {
            clearTimeout(timer);
        };
    }, [user, accountDetail]);

    useEffect(() => {
        if (user === null) {
            return;
        }
        const timer = setInterval(() => {
            checkVersionAndUpdateIfNeeded();
        }, 60000);
        return () => {
            clearTimeout(timer);
        };
    }, [user]);

    useEffect(() => {
        if (user !== null) {
            processScaffoldRequirements().then();
        }
    }, [user, accountDetail]);

    const processScaffoldRequirements = async () => {
        if (policyNoticeOpen.current) return;

        const userCount = accountDetail?.users?.filter(u => u.mobileNumber !== "-").length ?? 0;
        if (user && accountDetail?.id != null && userCount > 3) {
            const noticeKey = `${USER_POLICY_NOTICE_STORAGE_PREFIX}${accountDetail.id}:${user.id}`;
            let dismissed = shownPolicyNotices.current.has(noticeKey);
            try {
                dismissed = dismissed || localStorage.getItem(noticeKey) === "true";
            } catch {}

            if (!dismissed) {
                shownPolicyNotices.current.add(noticeKey);
                policyNoticeOpen.current = true;
                openDialog(<UserPolicyNotice userCount={userCount} isOwner={user.role === 1} />, () => {
                    policyNoticeOpen.current = false;
                    try {
                        localStorage.setItem(noticeKey, "true");
                    } catch {}
                });
                return;
            }
        }

        const popup = await getAvailablePopUp();

        if (popup) {
            openDialog(<Popup popup={popup} preview={false} key={popup.id} />);
        }
    };

    const getAvailablePopUp = async (): Promise<PopupDto | undefined> => {
        return PopupService.getAvailablePopup("1");
    };


    return <>{props.children}</>;
}
